import { render, staticRenderFns } from "./notOpen.vue?vue&type=template&id=748fa7a0&scoped=true&"
import script from "./notOpen.vue?vue&type=script&lang=js&"
export * from "./notOpen.vue?vue&type=script&lang=js&"
import style0 from "./notOpen.vue?vue&type=style&index=0&id=748fa7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fa7a0",
  null
  
)

export default component.exports